/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-21 10:49:59
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-05-27 16:18:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileLibrary/service.ts
 */
import {
  deleteResource,
  getResourceList,
  searchResource,
} from '@/src/request/mediaLibrary';
import { UploadFile } from 'antd/lib/upload/interface';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { defaultPageSize } from 'src/tools/constant';

function useService(canViewList: boolean) {
  const [loading, setLoading] = useState(false);
  const [hasBeenConfiged, setConfig] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [total, setTotal] = useState(0);
  const [tags, setTags] = useState([]);
  const [params, setParams] = useState({
    body: {},
    startIndex: 0,
    maxCount: defaultPageSize,
  });

  const featchData = () => {
    getResourceList(params.startIndex, params.maxCount, {
      ...params.body,
    })
      .then((response) => {
        const total = _.get(response, 'files.totalCount', 0);
        const fileList = _.get(response, 'files.results', []) || [];
        const tags = _.get(response, 'tags', []) || [];
        setTags(tags);
        setTotal(total);
        setFileList(fileList);
        setConfig(total ? true : false);
      })
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    featchData();
  }, []);

  const handleSearchFiles = async (params) => {
    try {
      setParams(params);
      setLoading(true);
      const response = await searchResource(
        params.startIndex,
        params.maxCount,
        params.body,
      );
      const total = _.get(response, 'totalCount');
      const files: Array<any> = _.get(response, 'results', []);
      setFileList(files);
      setTotal(total);
    } catch (e) {
      console.log(e, 'err');
    } finally {
      setLoading(false);
    }
  };

  const handleChangeFileList = ({ file, fileList, event }) => {
    const list = _.cloneDeep(
      fileList.sort((a, b) => (a.uid ? (b.uid ? 1 : -1) : 1)),
    );
    const index = inner_FindIndexOfFileList(file, fileList);
    if (index !== -1) {
      if (file.status === 'done') {
        const res = _.get(file, 'response.payload');
        list.splice(index, 1, res);
      } else if (file.status === 'error') {
        list.splice(index, 1);
      } else {
        list.splice(index, 1, file);
      }
      setFileList(list);
    } else {
      list.unshift(file);
      setFileList(list);
    }
  };

  const handleDeleteFiles = async (list: Array<string>) => {
    await deleteResource(list);
    await handleSearchFiles(params);
  };

  const inner_FindIndexOfFileList = (
    file: UploadFile,
    fileList: Array<UploadFile>,
  ) => {
    return fileList.findIndex((f) => f.uid === file.uid);
  };

  return {
    loading,
    tags,
    hasBeenConfiged,
    total,
    fileList: canViewList ? fileList : [],
    handleSearchFiles,
    handleDeleteFiles,
    handleChangeFileList,
    featchData,
  };
}

export default useService;
